import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class MarcasManual extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            consulta: false,
            modalEditar: false,
            modalBorrar: false,

            marBorrar:{
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },

            marEditar: {
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },

            consultaMarca: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
            },

            checkMarcas: {
                todas: true,
                telefono: false,
                tareaExterna: false,
                mediaHDescanso: false,
                planilla: false,
            },

            marcasManual : [],
            marcasTelefono: [],
            marcasTexterna: [],
            marcasMHDescanso: [],
            marcasPlanilla: [],
        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
    }
    async componentDidMount(){}
    render() {
        return (
            <>
                <Container>
                    <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <h3>Marcas Manual</h3>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    <Item>Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.consultaMarca.numeroFuncionario} onChange={this.manejarCambiosDatos} type="text" /></Item>
                                </Grid>
                                <Grid item xs={2.1}>
                                    <Item>Desde</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='desde' value={this.state.consultaMarca.desde} onChange={this.manejarCambiosDatos} type="date" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
                {this.state.consulta
                ?
                    <Container>
                        <FormControlLabel label='Marcas Manual' control={<Checkbox checked={this.state.checkMarcas.todas} onChange={this.cambioListadoConsulta} id='todas'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Marca Manual Teléfono' control={<Checkbox checked={this.state.checkMarcas.telefono} onChange={this.cambioListadoConsulta} id='telefono'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Marca Manual Tarea Externa' control={<Checkbox checked={this.state.checkMarcas.tareaExterna} onChange={this.cambioListadoConsulta} id='tareaExterna'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Marca Manual Media Hora Descanso' control={<Checkbox checked={this.state.checkMarcas.mediaHDescanso} onChange={this.cambioListadoConsulta} id='mediaHDescanso'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Marca Manual Panilla' control={<Checkbox checked={this.state.checkMarcas.planilla} onChange={this.cambioListadoConsulta} id='planilla'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        {this.state.checkMarcas.todas
                        ?
                            <TableContainer>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell>Tipo Marca</StyledTableCell>
                                            <StyledTableCell>Fecha</StyledTableCell>
                                            <StyledTableCell>Marca 1</StyledTableCell>
                                            <StyledTableCell>Marca 2</StyledTableCell>
                                            <StyledTableCell>Marca 3</StyledTableCell>
                                            <StyledTableCell>Marca 4</StyledTableCell>
                                            <StyledTableCell>Marca 5</StyledTableCell>
                                            <StyledTableCell>Marca 6</StyledTableCell>
                                            {/*<StyledTableCell></StyledTableCell>*/}
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.marcasManual.map((datosOmi) => (
                                            <StyledTableRow key={datosOmi.idMarcasManual}>
                                                <StyledTableCell>{datosOmi.tipoMarca}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                                <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                                {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>*/}
                                                <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            this.state.checkMarcas.telefono
                            ?
                                <TableContainer>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                            </TableRow>
                                            <TableRow>
                                                <StyledTableCell>Tipo Marca</StyledTableCell>
                                                <StyledTableCell>Fecha</StyledTableCell>
                                                <StyledTableCell>Marca 1</StyledTableCell>
                                                <StyledTableCell>Marca 2</StyledTableCell>
                                                <StyledTableCell>Marca 3</StyledTableCell>
                                                <StyledTableCell>Marca 4</StyledTableCell>
                                                <StyledTableCell>Marca 5</StyledTableCell>
                                                <StyledTableCell>Marca 6</StyledTableCell>
                                                {/*<StyledTableCell></StyledTableCell>*/}
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.marcasTelefono.map((datosOmi) => (
                                                <StyledTableRow key={datosOmi.idMarcasManual}>
                                                    <StyledTableCell>{datosOmi.tipoMarca}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                                    <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                                    {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>*/}
                                                    <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            :
                                this.state.checkMarcas.tareaExterna
                                ?
                                    <TableContainer>
                                        <Table sx={{minWidth: 700}}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <StyledTableCell>Tipo Marca</StyledTableCell>
                                                    <StyledTableCell>Fecha</StyledTableCell>
                                                    <StyledTableCell>Marca 1</StyledTableCell>
                                                    <StyledTableCell>Marca 2</StyledTableCell>
                                                    <StyledTableCell>Marca 3</StyledTableCell>
                                                    <StyledTableCell>Marca 4</StyledTableCell>
                                                    <StyledTableCell>Marca 5</StyledTableCell>
                                                    <StyledTableCell>Marca 6</StyledTableCell>
                                                    {/*<StyledTableCell></StyledTableCell>*/}
                                                    <StyledTableCell></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.marcasTexterna.map((datosOmi) => (
                                                    <StyledTableRow key={datosOmi.idMarcasManual}>
                                                        <StyledTableCell>{datosOmi.tipoMarca}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                                        <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                                        {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>*/}
                                                        <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                    this.state.checkMarcas.mediaHDescanso
                                    ?
                                        <TableContainer>
                                            <Table sx={{minWidth: 700}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <StyledTableCell>Tipo Marca</StyledTableCell>
                                                        <StyledTableCell>Fecha</StyledTableCell>
                                                        <StyledTableCell>Marca 1</StyledTableCell>
                                                        <StyledTableCell>Marca 2</StyledTableCell>
                                                        <StyledTableCell>Marca 3</StyledTableCell>
                                                        <StyledTableCell>Marca 4</StyledTableCell>
                                                        <StyledTableCell>Marca 5</StyledTableCell>
                                                        <StyledTableCell>Marca 6</StyledTableCell>
                                                        {/*<StyledTableCell></StyledTableCell>*/}
                                                        <StyledTableCell></StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.marcasMHDescanso.map((datosOmi) => (
                                                        <StyledTableRow key={datosOmi.idMarcasManual}>
                                                            <StyledTableCell>{datosOmi.tipoMarca}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                                            <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                                            {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>*/}
                                                            <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    :
                                        this.state.checkMarcas.planilla
                                        ?
                                            <TableContainer>
                                                <Table sx={{minWidth: 700}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <StyledTableCell>Tipo Marca</StyledTableCell>
                                                            <StyledTableCell>Fecha</StyledTableCell>
                                                            <StyledTableCell>Marca 1</StyledTableCell>
                                                            <StyledTableCell>Marca 2</StyledTableCell>
                                                            <StyledTableCell>Marca 3</StyledTableCell>
                                                            <StyledTableCell>Marca 4</StyledTableCell>
                                                            <StyledTableCell>Marca 5</StyledTableCell>
                                                            <StyledTableCell>Marca 6</StyledTableCell>
                                                            {/*<StyledTableCell></StyledTableCell>*/}
                                                            <StyledTableCell></StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.marcasPlanilla.map((datosOmi) => (
                                                            <StyledTableRow key={datosOmi.idMarcasManual}>
                                                                <StyledTableCell>{datosOmi.tipoMarca}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                                                <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                                                {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosOmi)}>Editar</button></StyledTableCell>*/}
                                                                <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosOmi)}>Borrar</button></StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        :
                                            null
                        }
                    </Container>
                :
                    null
                }
                {this.state.consulta
                ?
                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                :
                    null
                }
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Marca Manual?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>

                <Modal open={this.state.modalEditar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                            <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                <   Item>Número</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>{this.state.marEditar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={0.5}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Nombre: </Item>
                                </Grid>
                                <Grid item xs={4.5}>
                                    <Item>{this.state.marEditar.nombreFuncionario}</Item>
                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Marca 1: </Item>
                                </Grid>
                                <Grid item xs={0.1}>

                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='marca1' value={this.state.marEditar.marca1} onChange={this.manejarCambioEditar} type="text" /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <br/>
                <br/>
            </>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.consultaMarca.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar el número de funcionario!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.consultaMarca]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_marcasManual.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                notificaciones: null,
                consulta: false,
            });

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    marcasManual: exito[1],
                    marcasTelefono: exito[2],
                    marcasTexterna: exito[3],
                    marcasMHDescanso: exito[4],
                    marcasPlanilla: exito[5],
                    consulta: true,
                })
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
            checkMarcas: {
                todas: true,
                telefono: false,
                tareaExterna: false,
                mediaHDescanso: false,
                planilla: false,
            },
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.consultaMarca;
            funcionarioActualizado[clave] = valor;
            return{
                consultaMarca: funcionarioActualizado,
            };
        })
    }

    manejarEdicion(dato){
        this.setState({
            modalEditar: false,
            marEditar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            marBorrar: dato,
            notificaciones: null,
            errores: null,
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.marBorrar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_marcaManual.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito[0] === 'ok'){
            let contador = 0;
            const arr = this.state.marcasManual;
            arr.map((name) => {
                if(this.state.marBorrar.idMarcasManual === name.idMarcasManual){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                modalEditar: false,
                marcasManual: arr,
                errores: null,
                consulta: false,
                checkMarcas: {
                    todas: true,
                    telefono: false,
                    tareaExterna: false,
                    mediaHDescanso: false,
                    planilla: false,
                },
            });
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            modalBorrar: false,
            modalEditar: false,

            marBorrar:{
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },

            marEditar: {
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.marEditar;

            movEditarActualizado[clave] = valor;
            return {
                marEditar: movEditarActualizado,
            }
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
            modalEditar: false,
            modalBorrar: false,

            marBorrar:{
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },

            marEditar: {
                idMarcasManual: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                tipoMarca: '',
                fechaMarca: '',
                totalMarcas: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
            },

            consultaMarca: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
            },

            marcasManual : [],
        })
    }

    cambioListadoConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
            modalBorrarMH: false,
            modalBorrarES: false,
        });

        if(clave === 'todas'){

            if(valor){
                this.setState({
                    checkMarcas: {
                        todas: true,
                        telefono: false,
                        tareaExterna: false,
                        mediaHDescanso: false,
                        planilla: false,
                    },
                });
            }
        }else if(clave === 'telefono'){

            if(valor){
                this.setState({
                    checkMarcas: {
                        todas: false,
                        telefono: true,
                        tareaExterna: false,
                        mediaHDescanso: false,
                        planilla: false,
                    },
                });
            }
        }else if(clave === 'tareaExterna'){

            if(valor){
                this.setState({
                    checkMarcas: {
                        todas: false,
                        telefono: false,
                        tareaExterna: true,
                        mediaHDescanso: false,
                        planilla: false,
                    },
                });
            }
        }else if(clave === 'mediaHDescanso'){

            if(valor){
                this.setState({
                    checkMarcas: {
                        todas: false,
                        telefono: false,
                        tareaExterna: false,
                        mediaHDescanso: true,
                        planilla: false,
                    },
                });
            }
        }else if(clave === 'planilla'){

            if(valor){
                this.setState({
                    checkMarcas: {
                        todas: false,
                        telefono: false,
                        tareaExterna: false,
                        mediaHDescanso: false,
                        planilla: true,

                        checkMarcas: {
                            todas: true,
                            telefono: false,
                            tareaExterna: false,
                            mediaHDescanso: false,
                            planilla: false,
                        },
                    },
                });
            }
        }
    }

}

export default MarcasManual